export default function getRandomArrayElement(arr: string[]) {
  return arr[Math.floor(Math.random() * arr.length)];
}
